import { Logo } from '../Logo.tsx'
import { LogoAlva } from '../LogoAlva.tsx'
import { Tooltip } from './Tooltip.tsx'

export const PageHeader = () => {
  return (
    <>
      <div className="app-top border-b border-b-gray-400 bg-white transition ease-in-out duration-250 z-[200] will-change-transform top-0 print:hidden sticky">
        <header className="page-header grid items-center relative container is-wide">
          <a
            href={import.meta.env.VITE_MAIN_SITE_LINK}
            className="router-link-active router-link-exact-active block"
            aria-current="page"
          >
            <Logo />
          </a>
          <div className="page-header-console relative"></div>
          <a href="/" className="page-header-controls">
            <LogoAlva />
          </a>
          <Tooltip />
        </header>
      </div>
      <div className="container relative">
        <div className="relative breadcrumb-caret before:top-full"></div>
      </div>
    </>
  )
}
